import * as Analytics from 'analytics';

export const trackHamburgerClick  = () => {
    Analytics.trackEvent({
        category: 'Header',
        action: 'Navigation',
        label: 'Side menu - show'
    });
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/site-header.analytics.js